import(/* webpackMode: "eager" */ "/data/src/app/(domains)/article-detail/[slug]/index.tsx")